import If from "components/common/If";
import { RefObject } from "react";
import { InputErrorType } from "types/form-types";
import { BaseInputPropsType } from "../Input";
import InputErrors from "./InputErrors";
import InputLabel from "./InputLabel";

type InputWrapperPropsType = {
    errors: InputErrorType[],
    label?: BaseInputPropsType['label']
    required?: BaseInputPropsType['required']
    inputWrapperRef: RefObject<HTMLDivElement | null>
    children: React.ReactNode | React.ReactNode[],
    hideErrorMessages?: boolean,
    className?: string,
    wrapperClassName?: string,
    htmlFor?: string
}

const InputWrapper = (props: InputWrapperPropsType) => {
    const className = ((props.className || '') + ' input-container flex').trim();
    return (
        <div
            ref={props.inputWrapperRef}
            className={`app-input-wrapper ${props.wrapperClassName || ''}`}        
        >
            <label htmlFor={props.htmlFor}>
                <InputLabel label={props.label} required={props.required} />
                <div
                    className={className}
                >
                    {props.children}
                </div>
            </label>
            <If condition={!props.hideErrorMessages}>
                <InputErrors errors={props.errors} />
            </If>
        </div>
    )
}

export default InputWrapper;
